import React,{useState,useEffect} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import EditHomeForm from '../Components/HomeContent/EditHomeForm';
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config';
import { addDoc, collection, doc, getDoc, updateDoc } from 'firebase/firestore';
import { useParams,useNavigate } from 'react-router-dom';
const EditHomeBanner = () => {
    const [homeImage, setHomeImage] = useState("")
    const [homeName, setHomeName] = useState("")
    const [homeContent, setHomeContent] = useState("")
    const [homeLink, setHomeLink] = useState("")
    
    const {id} = useParams()
    const navigate = useNavigate()
    const addImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setHomeImage(downloadURL)
      
         console.log(downloadURL)
       });
     }
   );
   }
   const addHomeCarousel = () =>{
    const docRef = doc(db, "homeProperties",id);
    updateDoc(docRef,{
        name: homeName,
        image:homeImage,
        content:homeContent,
        link:homeLink
    })
    navigate("/home-list")
   }
   const fetchProperty = async () =>{
    const docRef = doc(db, "homeProperties", id);
const docSnap = await getDoc(docRef);
      
if (docSnap.exists()) {
  console.log("Document data:", docSnap.data());
  const data = docSnap.data()
    setHomeContent(data?.content)
    setHomeName(data?.name)
    setHomeImage(data?.image)
    setHomeLink(data?.link)
} else {
  // docSnap.data() will be undefined in this case
  console.log("No such document!");
}
   }
   useEffect(() => {
    fetchProperty()
   
     
   }, [id])
   
  return (
    <div>
        <MultiLevelSidebar />
        <EditHomeForm homeImage={homeImage}
       addHomeCarousel={addHomeCarousel}
        homeName={homeName}
        setHomeName={setHomeName}
        homeContent={homeContent}
        setHomeContent={setHomeContent}
        homeLink={homeLink}
        setHomeLink={setHomeLink}
        setHomeImage={setHomeImage}
          addImage={addImage} />
    </div>
  )
}

export default EditHomeBanner